import { type FC, type ReactNode, useState } from 'react'

import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem } from 'modules/core/components/GroupingExplotable'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface Props {
  level: { id: number; name: string }
  count: number
  children: ReactNode
}

const ExpandableGroup: FC<Props> = ({ level, count, children }) => {
  const [open, setOpen] = useState<boolean>(true)

  const handleToggle = () => {
    setOpen(!open)
    track(trackingEvents.jobCatalog.previewJobLevelToggleSubmit)
  }

  return (
    <ExplotableItem
      key={level.id}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Text.Normal size="200" weight="medium" color="grey800">
          {level.name} ({count})
        </Text.Normal>
      )}
      scrollLimited={false}
      size="small"
      toggle={handleToggle}
      type="primary"
    >
      {count > 0 && (
        <Table noRadius hideBorder>
          <Table.Body>{children}</Table.Body>
        </Table>
      )}
    </ExplotableItem>
  )
}

export default observer(ExpandableGroup)
